<template>
  <div class="copyright_container">
    <div class="copyright_box">
      <div class="title_box">
        <h2>农民日报社公司版权声明</h2>
      </div>
      <div class="content_box">
        <p>农民日报社公司（以下简称太极股份）旗下媒体所采访（拍摄）、编辑、制作、刊登（播出）的原创信息内容（包括但不限于文字作品、摄影作品、美术作品、视听作品、图形作品等）的版权均属太极股份所有。</p>
        <p>除法律规定情形外，任何第三方未经太极股份书面同意，不得转载、摘编或通过其它方式使用太极股份及其旗下媒体原创信息内容。自本声明发布之日起，太极股份将针对侵权行为加大监控和维权力度，依法采取有效措施，维护本公司合法权益。洽谈版权合作事宜，请联系太极股份，联系电话：010-57702888。</p>
        <p>农民日报社公司</p>
        <p>2022年1月1日</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
export default {
  name: "Copyright",
  data() {
    return {
      pageData: {
        title: "农民日报社公司版权声明",
        info: "",
        shareUrl: "",
        imageUrl: "",
      },
    };
  },
  computed: {
    ...mapState("app", ["shareRootUrl", "appFullName"]),
  },
  created() {
    document.title = this.pageData.title;
    loadStat(); // 友盟统计
    this.pageData.info = this.appFullName;
    this.pageData.shareUrl = this.shareRootUrl + "copyright";
    this.pageData.imageUrl = this.shareRootUrl.replace("/#/", "/") + require('@/assets/images/logo/logo.png');
  },
  mounted() {
    var _this = this;
    window.setShareInfo = () => {
      var shareStr = JSON.stringify(_this.pageData);
      // 调用客户端方法，将分享信息传给客户端
      if (window.java) {
        window.java.setShareInfo(shareStr);
      } else {
        _this.$bridge.callhandler("setShareInfo", shareStr, (data) => { });
      }
    }
  },
};
</script>
<style scoped lang="scss">
.copyright_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .copyright_box {
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    * {
      word-break: normal;
      white-space: normal;
      line-height: 1.5em;
    }
    .title_box {
      h2 {
        padding: 16px 0;
        line-height: 24px;
        text-align: center;
        color: #000;
        font-size: 16px;
        font-weight: bolder;
      }
    }
    .content_box {
      p {
        line-height: 24px;
        margin: 5px 0;
        color: #000;
        font-family: "宋体";
        font-size: 14px;
        text-indent: 2em;
        text-align: justify;
        * {
          font-family: "宋体";
          text-align: justify;
        }
      }
    }
  }
}
</style>